export default __webpack_public_path__ + "static/media/sections_sample.6b657c9f.jpg";